// Deps
import { FunctionComponent } from "react";

// internal-deps
import { ADDRESS_CATEGORIES, ANNOTATION_TYPES, DeliveryAddress } from "@swiggy-private/core-types";
import { HomeFilled12 } from "@swiggy-private/dls-web-food-icons/dist/web/homeFilled";
import { LocationFilled12 } from "@swiggy-private/dls-web-food-icons/dist/web/locationFilled";
import { WorkFilled12 } from "@swiggy-private/dls-web-food-icons/dist/web/workFilled";

// utils
import { convertToTitleCase } from "@core-ui/utils/String";
import { isEmpty } from "@swiggy-private/js-utils";

export const getAddressInfoFromDeliveryAddress = (deliveryAddress?: DeliveryAddress): string => {
    let addressInfoStr = "";
    const { flatNo = "", addressLine2 = "", landmark = "", address = "" } = deliveryAddress || {};

    if (flatNo) {
        addressInfoStr += `${flatNo}, `;
    }

    if (addressLine2) {
        addressInfoStr += `${addressLine2}, `;
    } else if (landmark) {
        addressInfoStr += `${landmark}, `;
    }

    if (address) {
        addressInfoStr += address;
    }

    return convertToTitleCase(addressInfoStr)?.trim();
};

export const getDeliveryAddressIcon = (category?: number): FunctionComponent => {
    let Element: FunctionComponent;

    switch (category) {
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_HOME:
            Element = HomeFilled12;
            break;
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_WORK:
            Element = WorkFilled12;
            break;
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_FRIENDS_AND_FAMILY:
            Element = HomeFilled12;
            break;
        default:
            Element = LocationFilled12;
            break;
    }
    return Element;
};

export const getAddressAnnotation = (address?: DeliveryAddress, category?: number): string => {
    if (isEmpty(address)) return ANNOTATION_TYPES.OTHER;
    let deliveryAnnotation = "";
    switch (category) {
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_HOME:
            deliveryAnnotation = ANNOTATION_TYPES.HOME;
            break;
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_WORK:
            deliveryAnnotation = ANNOTATION_TYPES.WORK;
            break;
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_FRIENDS_AND_FAMILY:
            deliveryAnnotation = address?.name || ANNOTATION_TYPES.HOME;
            break;
        default:
            deliveryAnnotation = address?.annotation || ANNOTATION_TYPES.OTHER;
            break;
    }
    return deliveryAnnotation;
};
